const useDeepLinkWarmup = () => {
  return { isWarmingUp: false }
}

export default useDeepLinkWarmup
